import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            notSetPictureUrl: String
        };
    }

    static get targets() {
        return ["previewPicture", "pictureFile", "presetPicture"];
    }

    selectPictureFile() {
        const [file] = this.pictureFileTarget.files;
        this.previewPictureTarget.style.backgroundImage = `url("${file ? URL.createObjectURL(file) : this.notSetPictureUrlValue}")`;
        this.presetPictureTargets.forEach(ppt => {
            ppt.checked = false;
        });
    }

    selectPresetPicture({ target }) {
        this.previewPictureTarget.style.backgroundImage = `url("${target.parentNode.querySelector("img").src}")`;
        this.pictureFileTarget.value = null;
    }
}